export default __webpack_public_path__ + "static/media/paymentSuccess.d873a43d.png";